import { useState, useContext, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ButtonLoading from "../animations/ButtonLoading";
import { AuthUserContext } from "../../context/AuthUserContext";
import SimpleContext from "../../context/SimpleContext";
import ForgotPassword from "./ForgotPassword";
import { useNavigation } from "../../utils/navigation";
import { useDispatch, useSelector } from "react-redux";
import refreshCartPrices from "../../utils/cart";

const Container = styled.div`
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #00000027;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  min-height: 100vh;
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  width: 90%;

  background-color: #1a2c38;
  background-color: var(--bg-200);
  position: relative;
  overflow: auto; /* omogućava skrolanje unutar div-a */
  -webkit-overflow-scrolling: touch;

  padding: 20px 0;
  border-radius: 14px;
  @media (min-width: 768px) {
    width: 500px;
    min-height: auto;
  }
`;
const FormWrapper = styled.div`
  min-width: 90%;
  max-width: 90%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const FormContainer = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    width: 500px;
  }
`;
const SocialContainer = styled.div`
  width: 20%;
  height: 40px;
  background-color: #2f4553;

  background-color: var(--bg-100);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  &:hover {
    background-color: var(--bg-200);
  }
`;
const ExitContainer = styled.div`
  display: block;
  position: absolute;
  top: 20px;
  cursor: pointer;
  right: 10%;
`;
const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  //gap: 8px;
  margin: 10px 0;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-base);
  color: var(--primary-200);
  font-weight: 100;
  text-transform: capitalize;
  gap: var(--spacing-xs);
  margin-bottom: var(--spacing-lg);
`;

const Title = styled.h1`
  font-size: var(--font-size-xlarge);
  text-align: center;
  font-weight: 400;
  padding: 0;
  margin: 0;
  color: var(--text-200);
  text-transform: uppercase;
  margin-bottom: var(--spacing-sm);
  padding-bottom: var(--spacing-xs);

  border-bottom: 1px solid var(--bg-300);
`;
const Subtitle = styled.div`
  font-size: var(--font-size-small);
  color: var(--text-100);
  text-align: center;

  margin-bottom: var(--spacing-xl);
`;

const Input = styled.input`
  outline: none;
  padding: var(--spacing-sm) 0 var(--spacing-sm) var(--spacing-xs);
  border: 1px solid #ccc;
  width: calc(100% - 8px);
  font-size: var(--font-size-small);
  color: var(--text-200);
  background-color: var(--bg-200);
  margin: var(--spacing-xxs) 0 var(--spacing-md) 0;
  ::placeholder {
    font-size: var(--font-size-small);
    color: var(--p-color);
  }

  border-radius: 4px;
`;
const Label = styled.label`
  font-size: var(--font-size-base);
  text-transform: capitalize;
  color: var(--text-200);
  text-align: left;
  min-width: 100%;
`;
const SmallTitle = styled.div`
  font-size: 20px;
  text-align: center;
  padding: 0;
  margin: 0;
  margin-bottom: var(--spacing-xl);
  font-size: var(--font-size-small);
  margin: 12px 0;
  color: var(--p-color);
`;
const ButtonWrapper = styled.div`
  position: relative; /* Roditeljski kontejner koji omogućava apsolutno pozicioniranje za decu */
  display: inline-block; /* Omogućava kontejneru da se prilagodi veličini sadržaja */
  width: 90%;
  text-align: center;
  //margin: var(--spacing-md) 0;
`;
const Button = styled.button`
  width: 100%;
  height: 50px;
  background-color: var(--text-200);
  text-transform: capitalize;
  border-radius: 8px;
  border-color: var(--text-200);
  &:hover {
    background-color: var(--bg-200);
    color: var(--text-200);
  }
`;

const EyeSVG = styled.svg`
  position: absolute;
  right: 40px;
  top: 0;
  width: var(--font-size-xlarge);
  height: var(--font-size-xlarge);
`;
const EyeSpan = styled.span`
  position: relative;
`;
const ButtonLink = styled.button`
  align-self: flex-end;

  color: var(--text-100);
  font-size: var(--font-size-small);
  font-weight: 500;
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 12px 0;
  margin-left: 5%;
  text-decoration: underline;
  &:hover {
    background-color: transparent;
  }
`;

const RegisterContainer = styled.div`
  width: 90%;
  padding: 30px 0px;
  background-color: var(--bg-100);
  margin: 0 auto;
  border-radius: 8px;
`;

const Login = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const { loginUser, handleGoogleLogin } = useContext(AuthUserContext);
  const { closeLoginPopup } = useContext(SimpleContext);
  const { goToRegister } = useNavigation();
  const navigate = useNavigate();

  const [isAnimating, setIsAnimating] = useState(false);

  const dispatch = useDispatch();
  const itemsList = useSelector((state) => state.cart.itemsList);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsAnimating(true);
    try {
      await loginUser(email, password);
      // Redirect na home page ili neku drugu stranicu nakon uspešnog logina
      // Možete koristiti useNavigate hook iz react-router-dom za navigaciju
      await refreshCartPrices(dispatch, itemsList);
      closeLoginPopup();
    } catch (err) {
      if (err.response && err.response.status === 401) {
      } else {
      }
    }
  };
  const handleAnimationComplete = () => {
    setIsAnimating(false);
  };

  // script.js

  const location = useLocation();
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    // Funkcija koja će se pozvati kada se popup ukloni iz URL-a
    const handlePopupRemoved = () => {
      console.log("popup je uklonjen iz URL-a");
      // Ovde možete pozvati vašu funkciju po želji
    };
    if (initialLoad) {
      setInitialLoad(false);
      return;
    }
    const checkPopupParam = () => {
      const newSearchParams = new URLSearchParams(window.location.search);

      if (!newSearchParams.has("popup")) {
        handlePopupRemoved();
      }
    };

    if (!searchParams.has("popup")) {
      handlePopupRemoved();
    }

    // Praćenje promena u URL-u
    window.addEventListener("popstate", checkPopupParam);

    return () => {
      window.removeEventListener("popstate", checkPopupParam);
    };
  }, [location]);

  return (
    <>
      {!forgotPassword ? (
        <Container>
          <Wrapper
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <FormContainer>
              <ExitContainer
                onClick={() => {
                  closeLoginPopup(false);
                }}
              >
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 1024 1024"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="var(--text-200)"
                    d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
                  />
                </svg>
              </ExitContainer>
              <>
                <Title>{t("LOGIN.TITLE")}</Title>
                <Subtitle>{t("LOGIN.SUBTITLE")}</Subtitle>
                <Form onSubmit={handleSubmit}>
                  <FormWrapper>
                    <Label htmlFor="email">{t("LABELS.EMAIL")}</Label>
                    <Input
                      type="email"
                      id="email"
                      value={email}
                      placeholder={t("PLACEHOLDERS.EMAIL")}
                      onChange={(e) =>
                        setEmail(e.target.value.replace(/\s/g, ""))
                      }
                      required
                    />
                  </FormWrapper>

                  <FormWrapper>
                    <Label htmlFor="password">{t("LABELS.PASSWORD")}</Label>
                    <EyeSpan>
                      <Input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        placeholder={t("PLACEHOLDERS.PASSWORD")}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      {showPassword ? (
                        <EyeSVG
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <g id="style=fill">
                            <g id="eye-close">
                              <path
                                id="vector"
                                d="M15.6487 5.39465C14.4859 4.95229 13.2582 4.71997 12 4.71997C8.46997 4.71997 5.17997 6.54861 2.88997 9.71356C1.98997 10.9532 1.98997 13.0368 2.88997 14.2764C3.34474 14.9049 3.83895 15.4807 4.36664 16M19.3248 7.69629C19.9692 8.2894 20.5676 8.96401 21.11 9.71356C22.01 10.9532 22.01 13.0368 21.11 14.2764C18.82 17.4413 15.53 19.27 12 19.27C10.6143 19.27 9.26561 18.9882 7.99988 18.4544"
                                stroke="var(--text-color-hover)"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                id="Subtract"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M17.742 5.57955C15.9962 4.53817 14.0413 3.96997 11.9998 3.96997C8.19594 3.96997 4.69275 5.94267 2.28258 9.27342C1.72076 10.0475 1.46484 11.0419 1.46484 11.995C1.46484 12.9478 1.72065 13.942 2.28222 14.716C3.02992 15.7494 3.88282 16.6521 4.81727 17.4057L8.72514 13.83C8.42248 13.2886 8.25 12.664 8.25 12C8.25 9.92657 9.92657 8.25 12 8.25C12.7834 8.25 13.5113 8.48997 14.1129 8.90023L17.742 5.57955ZM6.0677 18.2947C7.86114 19.4096 9.88397 20.02 11.9998 20.02C15.8037 20.02 19.3069 18.0473 21.7171 14.7165C22.2789 13.9424 22.5348 12.948 22.5348 11.995C22.5348 11.0421 22.279 10.0479 21.7175 9.27392C20.9248 8.17837 20.0139 7.22973 19.0129 6.44988L6.0677 18.2947ZM15 11.25C15.4142 11.25 15.75 11.5858 15.75 12C15.75 14.0734 14.0734 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15C11.25 14.5858 11.5858 14.25 12 14.25C13.245 14.25 14.25 13.245 14.25 12C14.25 11.5858 14.5858 11.25 15 11.25Z"
                                fill="var(--text-color-hover)"
                              />
                              <path
                                id="vector (Stroke)"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M22.5533 2.19366C22.8329 2.49926 22.8119 2.97366 22.5063 3.25328L19.3012 6.18591C18.9956 6.46553 18.5212 6.44447 18.2416 6.13888C17.962 5.83329 17.9831 5.35888 18.2886 5.07926L21.4937 2.14663C21.7993 1.86701 22.2737 1.88807 22.5533 2.19366ZM5.73136 17.5857C6.01098 17.8913 5.98992 18.3657 5.68433 18.6454L2.5063 21.5533C2.2007 21.8329 1.7263 21.8118 1.44668 21.5062C1.16706 21.2006 1.18812 20.7262 1.49371 20.4466L4.67175 17.5387C4.97734 17.2591 5.45175 17.2801 5.73136 17.5857Z"
                                fill="var(--text-color-hover)"
                              />
                            </g>
                          </g>
                        </EyeSVG>
                      ) : (
                        <EyeSVG
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <g id="style=fill">
                            <g id="eye-open">
                              <path
                                id="Subtract"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12.0001 3.96997C8.19618 3.96997 4.69299 5.94267 2.28282 9.27342C1.721 10.0475 1.46509 11.0419 1.46509 11.995C1.46509 12.9478 1.7209 13.942 2.28246 14.716C4.69264 18.0471 8.19599 20.02 12.0001 20.02C15.804 20.02 19.3072 18.0473 21.7174 14.7165C22.2792 13.9424 22.5351 12.948 22.5351 11.995C22.5351 11.0421 22.2793 10.0479 21.7177 9.27392C19.3075 5.94286 15.8042 3.96997 12.0001 3.96997ZM9.75012 12C9.75012 10.755 10.7551 9.75 12.0001 9.75C13.2451 9.75 14.2501 10.755 14.2501 12C14.2501 13.245 13.2451 14.25 12.0001 14.25C10.7551 14.25 9.75012 13.245 9.75012 12ZM12.0001 8.25C9.92669 8.25 8.25012 9.92657 8.25012 12C8.25012 14.0734 9.92669 15.75 12.0001 15.75C14.0736 15.75 15.7501 14.0734 15.7501 12C15.7501 9.92657 14.0736 8.25 12.0001 8.25Z"
                                fill="var(--text-color-hover)"
                              />
                            </g>
                          </g>
                        </EyeSVG>
                      )}
                    </EyeSpan>
                  </FormWrapper>

                  <ButtonWrapper>
                    <Button type="submit">{t("BUTTONS.SUBMIT")}</Button>
                    {isAnimating && (
                      <ButtonLoading
                        isAnimating={isAnimating}
                        onComplete={handleAnimationComplete}
                      />
                    )}
                  </ButtonWrapper>
                </Form>
                <ButtonLink
                  onClick={() => {
                    setForgotPassword(true);
                  }}
                >
                  Forgot Password?{" "}
                </ButtonLink>
              </>
              <RegisterContainer>
                <Button
                  style={{ width: "90%", margin: "0 auto" }}
                  onClick={() => {
                    closeLoginPopup();
                    navigate(goToRegister());
                  }}
                >
                  Bli medlem här
                </Button>
              </RegisterContainer>
            </FormContainer>
          </Wrapper>
        </Container>
      ) : (
        <ForgotPassword setForgotPassword={setForgotPassword} />
      )}
    </>
  );
};

export default Login;
